import { DataBox, createDataBox, createDataBoxDefault } from 'app/common/data-box-store'
import { ItemType } from 'app/common/ui-next/plain-radio-button'
import { FinancesSummaryDetailsGroup } from 'app/dataTypes/reports/data/common/financesSummary'


export type FinancesSummaryDetailsList = Array<ItemType>

class FinancesSummaryDataBox extends DataBox<FinancesSummaryDetailsList> { }

export const defaultFinancesSummary: FinancesSummaryDetailsList = []
export const financesSummaryGroupFilter = createDataBox('financesSummaryGroupFilter', defaultFinancesSummary, FinancesSummaryDataBox)

export const defaultFinancesSummaryGroupData = () => {
  return [
    {
      id: FinancesSummaryDetailsGroup.Dates,
      title: 'датам',
    },
    {
      id: FinancesSummaryDetailsGroup.Students,
      title: 'учащимся',
    },
  ]
}

financesSummaryGroupFilter.updateData(defaultFinancesSummaryGroupData)
financesSummaryGroupFilter.setStatusReady()


export const defaultFinancesSummaryFilterSelection: string = FinancesSummaryDetailsGroup.Dates
export const financesSummaryGroupFilterSelection = createDataBoxDefault<string>('financesSummaryGroupFilterSelection', defaultFinancesSummaryFilterSelection)
